import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';

var Colgroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Colgroup, _React$Component);

  var _super = _createSuper2(Colgroup);

  function Colgroup(props) {
    var _this;

    _classCallCheck(this, Colgroup);

    _this = _super.call(this, props);
    _this.state = {
      didShow: false
    };
    return _this;
  }

  _createClass(Colgroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          colgroup = _this$props.colgroup,
          columns = _this$props.columns,
          resizable = _this$props.resizable;

      if (!colgroup && resizable && this.state.didShow) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          didShow: false
        });
        return;
      }

      if (!resizable || this.state.didShow) return;
      if (!colgroup || colgroup.length !== columns.length) return; // eslint-disable-next-line react/no-did-update-set-state

      this.setState({
        didShow: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var didShow = this.state.didShow;
      var _this$props2 = this.props,
          columns = _this$props2.columns,
          colgroup = _this$props2.colgroup;

      if (colgroup && colgroup.length === columns.length) {
        return (
          /*#__PURE__*/
          React.createElement("colgroup", null, colgroup.map(function (c, i) {
            var last = colgroup.length - 1 === i;
            if (didShow && last) return null;
            return (
              /*#__PURE__*/
              React.createElement("col", {
                key: columns[i].key,
                style: {
                  width: c
                }
              })
            );
          }))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("colgroup", null, columns.map(function (c, i) {
          var last = columns.length - 1 === i;
          if (didShow && last) return null;
          return (
            /*#__PURE__*/
            React.createElement("col", {
              key: c.key,
              style: {
                width: c.width
              }
            })
          );
        }))
      );
    }
  }]);

  return Colgroup;
}(React.Component);

export default Colgroup;